import React from 'react';
import product from '../images/shop/product.png';
import product2 from '../images/shop/product2.png';
import { ChevronLeft } from 'lucide-react'; // Import the left arrow icon from Lucide
import { Link } from 'react-router-dom';

// Mock data based on the image
const monitorData = {
  name: 'ZUS238GMG',
  description:
    'Uživajte u glatkom i responzivnom gejming iskustvu na ovom Full HD monitoru. Sa brzinom osvežavanja od 165Hz i vremenom odziva od samo 1ms, doživećete izuzetno fluidno kretanje i oštru sliku.',
  imageUrl: product, // Replace with the actual image URL
  thumbnailUrls: [
    product,
    product2,
    product,
    product2,
  ],
  specifications: [
    { label: 'Dijagonala ekrana:', value: '23.8"' },
    { label: 'Tip panela:', value: 'IPS' },
    { label: 'Odziv:', value: '1ms' },
    { label: 'Osvežavanje:', value: '165Hz' },
    { label: 'Konektori:', value: '2x HDMI' },
    { label: 'Veličina piksela:', value: '0.245x0.245cm' },
    { label: 'VESA:', value: '100x100' },
    {
      label: 'Ostalo:',
      value: [
        'Lorem ipsum',
        'Lorem ipsum',
        'Lorem ipsum',
        'Lorem ipsum',
      ],
    },
  ],
};

const ProductDetails: React.FC = () => {
  const [mainImageUrl, setMainImageUrl] = React.useState(monitorData.imageUrl);

  const handleThumbnailClick = (url: string) => {
    setMainImageUrl(url);
  };
  
  return (
    <div className='w-full pb-20 bg-white md:rounded-b-3xl'>
      <div className="flex flex-col items-center font-sans md:p-8 md:flex-row lg:justify-center lg:items-start bg-white container mx-auto">
        <div className="flex flex-col items-center pt-0 pb-5 md:pr-10 md:pb-0 bg-[#f8f8f8] md:bg-white z-50 w-full px-10 rounded-b-[7%] md:rounded-none shadow-lg md:shadow-none">
          {/* Back Button */}
          <div className='h-[250px] flex items-center justify-center'>
            <Link to='/shop' className='md:hidden'>
              <button
                className="absolute top-24 left-5 bg-yellow-400 text-black rounded-full w-8 h-8 flex items-center justify-center cursor-pointer z-10"
              >
                <ChevronLeft className='text-white'/>
              </button>
            </Link>
            <img
              src={mainImageUrl}
              alt={monitorData.name}
              className="h-[90%] self-center rounded-md"
            />
          </div>
          <div className="flex gap-2 mt-2 overflow-x-scroll mini-img">
            {monitorData.thumbnailUrls.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Thumbnail ${index + 1}`}
                className="w-24 h-20 rounded-sm cursor-pointer transition-opacity hover:opacity-100 bg-white"
                onClick={() => handleThumbnailClick(url)}
              />
            ))}
          </div>
        </div>

        <div className="flex flex-col w-full justify-center h-full text-justify px-10 bg-white md:self-center mt-10 md:mt-0">
          <div className='flex flex-row justify-between'>
            <h2 className="text-xl md:text-2xl font-normal text-gray-800 mb-2 flex flex-col md:flex-row">
              Monitor <span className='text-2xl md:text-2xl md:ml-1 font-bold md:font-normal text-gray-800'>{monitorData.name}</span>
            </h2>
            <button className="bg-[#ff9900] text-white text-sm font-bold py-1.5 px-3 self-center rounded-2xl cursor-pointerflex md:hidden transition-colors self-start">
              Gde kupiti?
            </button>
          </div>
          <p className="text-gray-600 text-sm mb-4 mt-10 md:mt-0">
            {monitorData.description}
          </p>
          
          <p className="text-gray-600 text-sm mb-2">
            {monitorData.description}
          </p>
          {/*           
          <p className="text-gray-600 text-sm mb-4">
            {monitorData.description}
          </p>
          
          <p className="text-gray-600 text-sm mb-4">
            {monitorData.description}
          </p> 
          */}
          <a
            href="#"
            className="text-[#ff9900] text-sm text-bold mt-1 block hover:underline"
          >
            Vidi više ›
          </a>
          <button className="bg-[#ff9900] text-white font-bold py-2 px-6 rounded-md cursor-pointer hidden md:flex transition-colors self-start mb-5">
            Gde kupiti?
          </button>
        </div>
      </div>
      <div className="bg-white mx-10 md:mx-auto py-5 rounded-lg md:px-5 bg-white container w-auto">
        <h3 className="text-xl font-semibold text-gray-800 mb-3 bg-white">
          Specifikacija
        </h3>
        {monitorData.specifications.map((spec, index) => (
          <div key={index} className="grid grid-cols-2 gap-y-2 py-2">
            <span className="bg-[#f8f8f8] w-[calc(100%-10px)] py-2 rounded-xl"><span className='text-normal text-sm pl-3'>{spec.label}</span></span>
            {Array.isArray(spec.value) ? (
              <ul className='bg-[#f8f8f8] w-[calc(100%-10px)] py-2 rounded-xl'>
                {spec.value.map((item, i) => (
                  <li key={i}><span className='text-normal text-sm pl-3'>{item}</span></li>
                ))}
              </ul>
            ) : (
              <span className="bg-[#f8f8f8] w-[calc(100%-10px)] py-2 rounded-xl"><span className='text-normal text-sm pl-3'>{spec.value}</span></span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductDetails;